import React from 'react';
import { Loader } from 'semantic-ui-react';
import { pollingStatus, successfulPollingStatuses } from '../constants';
import RequestConfirmationError from './RequestConfirmationError';
import RequestConfirmationSuccess from './RequestConfirmationSuccess';
import RequestConfirmationDelayed from './RequestConfirmationDelayed';
import RequestApproveSuccess from './RequestApproveSuccess';
import DatasetSubscribeMessageContainer from '../subscriptions/components/DatasetSubscribeMessageContainer';
import RequestConfirmationMessage from './RequestConfirmationMessage';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const StatusComponent = {
  created: RequestConfirmationSuccess,
  approved: RequestApproveSuccess,
  delayed: RequestConfirmationDelayed,
  errored: RequestConfirmationError,
};

const RequestConfirmation = ({ category, code }) => {
  const { polling, saveStatus } = Selectors.useRequestConfirmation({ category, code });
  Fetch.usePollRequest({
    category, code, polling, saveStatus,
  });
  const Component = StatusComponent[polling];

  return (
    <div className="aridhia-request-confirmation flex flex-column justify-between aridhia-wizard-content">
      <div>
        {polling === pollingStatus.POLLING && (<Loader active inline="centered" />)}
        {Component && (<Component category={category} code={code} />)}
        <RequestConfirmationMessage polling={polling} />
      </div>
      {successfulPollingStatuses.includes(polling) && (
      <DatasetSubscribeMessageContainer code={code} category={category} />
      )}
    </div>
  );
};

export default RequestConfirmation;
